<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import { useMapGetter } from 'dashboard/composables/store';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');

const userRole = computed(() => {
  const accounts = currentUser.value?.accounts || [];
  const account = accounts.find(
    a => Number(a.id) === Number(route.params.accountId)
  );
  return account?.role || 'agent';
});

const isAdmin = computed(() =>
  ['administrator', 'manager'].includes(userRole.value)
);

const title = computed(() => t('APP_GLOBAL.PAYMENT_SUSPENDED.TITLE'));

const message = computed(() =>
  isAdmin.value
    ? t('APP_GLOBAL.PAYMENT_SUSPENDED.MESSAGE_ADMIN')
    : t('APP_GLOBAL.PAYMENT_SUSPENDED.MESSAGE_AGENT')
);

const goToBilling = () => {
  router.push({
    name: 'billing_portal_index',
    params: { accountId: route.params.accountId },
  });
};
</script>

<template>
  <div class="items-center bg-n-slate-2 flex justify-center h-full w-full">
    <div class="flex flex-col items-center gap-6 max-w-md text-center px-6">
      <EmptyState :title="title" :message="message" />
      <button
        v-if="isAdmin"
        type="button"
        class="h-10 px-6 rounded-md bg-n-brand text-white text-sm font-medium"
        @click="goToBilling"
      >
        {{ t('APP_GLOBAL.PAYMENT_SUSPENDED.ACTION_ADMIN') }}
      </button>
    </div>
  </div>
</template>
